import { autoMount } from '../../../utils/autoMount';
import { FooterListed } from '../../../components/organisms/footerListed';

autoMount({ FooterListed });
